import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Text from './Text';
import { Spacer } from './index';
import useThemeContext from '../styles/useThemeContext';
import TouchableNative from './TouchableNative';
import Icon from './Icon';
import { toggleCardCollapse } from '../../modules/Feed/actions';
import Collapsible from 'react-native-collapsible';
import { designConstants } from '../styles';
import TextButton from './TextButton';

export default function CollapsibleCardContainer(props) {
  const {
    title,
    children,
    bottomButton,
    style,
    noPadding,
    renderHeaderRight,
    renderHeaderLeft,

    onLayout,
    onBottomButtonPress,
    type,
  } = props;
  const theme = useThemeContext();
  const dispatch = useDispatch();
  const collapsed = useSelector(
    (state) => state.feed.cards.find((c) => c.type === type)?.collapsed,
  );

  const toggleExpand = () => {
    dispatch(toggleCardCollapse(type));
  };

  return (
    <View style={{ marginVertical: 5 }}>
      <View
        style={[
          cardItemWideStyles.headerContainer,
          { backgroundColor: theme.colors.cardHeader },
        ]}
      >
        {renderHeaderLeft ? (
          renderHeaderLeft()
        ) : (
          <Text bold style={[cardItemWideStyles.title]}>
            {title}
          </Text>
        )}
        {renderHeaderRight && (
          <>
            <Spacer />
            <View
              style={{
                paddingHorizontal: 10,
              }}
            >
              {renderHeaderRight()}
            </View>
          </>
        )}
        <TouchableNative
          onPress={toggleExpand}
          style={{
            paddingLeft: 10,
          }}
        >
          <View>
            <Icon
              type="MaterialIcons"
              name={collapsed ? 'expand-more' : 'expand-less'}
              color={theme.colors.textSecondary}
            />
          </View>
        </TouchableNative>
      </View>
      <Collapsible
        style={[
          cardItemWideStyles.container,
          { backgroundColor: theme.colors.cardContainer },
          style,
        ]}
        collapsed={collapsed}
      >
        <View>
          <View
            style={!noPadding && cardItemWideStyles.content}
            onLayout={onLayout}
          >
            {children}
          </View>
          {bottomButton && (
            <TextButton
              style={cardItemWideStyles.bottomButton}
              text={bottomButton}
              onPress={onBottomButtonPress}
              ignoreSentenceCase
            />
          )}
        </View>
      </Collapsible>
    </View>
  );
}

const cardItemWideStyles = StyleSheet.create({
  container: {},
  content: {
    paddingHorizontal: designConstants.paddings.edgePadding,
    paddingVertical: designConstants.paddings.edgePadding,
    alignSelf: 'stretch',
  },
  bottomButton: {
    alignSelf: 'flex-start',
    borderRadius: 0,
    fontWeight: 500,
    paddingHorizontal: designConstants.paddings.edgePadding,
    minHeight: 0,
    paddingVertical: designConstants.paddings.edgePadding / 2,
    marginBottom: designConstants.paddings.edgePadding / 2,
    marginTop: -designConstants.paddings.edgePadding / 2,
    justifyContent: 'center',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 48,
    paddingHorizontal: designConstants.paddings.edgePadding,
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
  },
});
